import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useAuth } from '@zep/auth';
import { Language } from '@zep/types';
import { Pagination } from '@zep/ui';
import StarRating from '../../../../components/service/common/StarRating';
import { useStoreItemDetail, useStoreItemReviews } from '../../../../services';
import { AssetCommonHashIdProps } from '../../../../types/StoreTypes';
import S from './StoreReviewLayout.module.scss';
import StoreReviewList from './StoreReviewList';
import StoreReviewWriter from './StoreReviewWriter';
const REVIEWS_COUNT_PER_PAGE = 4;
const StoreReviewLayout = ({
  assetHashId
}: AssetCommonHashIdProps) => {
  const {
    user
  } = useAuth();
  const {
    locale
  } = useRouter();
  const [currentPage, setCurrentPage] = useState(1);
  const {
    t
  } = useTranslation(['store']);
  const assetDetails = useStoreItemDetail(assetHashId, locale as Language, !!user?.isEdu);
  const reviewData = useStoreItemReviews(assetHashId, currentPage, !!user?.isEdu);
  const [rate, setRate] = useState(0);
  useEffect(() => {
    const sum = assetDetails.data?.ratingSum || 0;
    const count = reviewData.data?.pager.totalItems ?? 0;
    const ratingAverage = sum === 0 || count === 0 ? 0 : sum / count;
    setRate(ratingAverage);
  }, [assetDetails.data, reviewData.data]);
  if (!assetDetails.isSuccess || !reviewData.isSuccess) {
    return <></>;
  }
  return <div className={S.details_review_container} data-sentry-component="StoreReviewLayout" data-sentry-source-file="StoreReviewLayout.tsx">
      <div className={S.detail_writer_wrapper}>
        <StoreReviewWriter assetHashId={assetHashId} reviewTotalPage={reviewData.data.pager?.totalPages} data-sentry-element="StoreReviewWriter" data-sentry-source-file="StoreReviewLayout.tsx" />
      </div>
      <div className={S.detail_reviewlist_wrapper}>
        <label className={S.detail_title}>
          {t('store:store_reviews_list')}
        </label>
        <div className={S.rating_sum_wrapper}>
          <label className={S.detail_title}>
            {rate > 0 ? rate.toFixed(1) : rate} (
            {reviewData.data.pager.totalItems})
          </label>
          <StarRating starMaxCount={5} filledCount={Math.floor(rate)} isClickable={false} data-sentry-element="StarRating" data-sentry-source-file="StoreReviewLayout.tsx" />
        </div>
        {reviewData.data.comments && <StoreReviewList reviewList={reviewData.data.comments} />}
        <Pagination nowPageNo={reviewData.data.pager?.currentPage} lastPageNo={reviewData.data.pager?.totalPages} printableCount={REVIEWS_COUNT_PER_PAGE} onPageChange={(page: number) => setCurrentPage(page)} data-sentry-element="Pagination" data-sentry-source-file="StoreReviewLayout.tsx" />
      </div>
    </div>;
};
export default StoreReviewLayout;